
import Vue from "vue";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import { CreateTruckTemplateRequest } from "../../models/api/truckTemplate/createTruckTemplates";
import Select from "../../components/form/Select.vue";
import { UpdateTruckTemplateRequest } from "@/models/api/truckTemplate/updateTruckTemplates";
import notifications from "../../lib/notifications";
import TruckZip3OverridesModule from "@/store/modules/truckZip3Overrides";
import { TruckZip3Overrides } from "@/models/api/truckZip3Overrides/getTruckZip3Overrides";
import { CreateTruckZip3OverridesRequest } from "@/models/api/truckZip3Overrides/createTruckZip3Overrides";
import { UpdateTruckZip3OverridesRequest } from "@/models/api/truckZip3Overrides/updateTruckZip3Overrides";

const truckZip3OverridesModuleState = getModule(TruckZip3OverridesModule);

@Component({
  components: {
    Select
  }
})
export default class NewTruckZip3Overrides extends Vue {
  newTruckZip3Overrides: AddOverrideZip3ViewModel = {
    zipCode: null,
    overrideZip3: null,
    facilityCode: null,
    id: null
  };
  saving: boolean = false;
  async created() {
    if (this.$route.params.id) {
      let result: TruckZip3Overrides = await truckZip3OverridesModuleState.getTruckZip3Overrides(
        +this.$route.params.id
      );

      this.newTruckZip3Overrides = {
        ...result
      };
    }
  }

  resetModal() {}

  async submit() {
    this.saving = true;
    let hasErrors: boolean = false;

    try {
      if (!this.newTruckZip3Overrides.id) {
        const zip3OverridesRequest: CreateTruckZip3OverridesRequest = {
          facilityCode: this.newTruckZip3Overrides.facilityCode,
          overrideZip3: this.newTruckZip3Overrides.overrideZip3.toString(),
          zipCode: this.newTruckZip3Overrides.zipCode.toString()
        };
        const response = await truckZip3OverridesModuleState.createTruckZip3Overrides(
          zip3OverridesRequest
        );
      } else {
        const zip3OverridesRequest: UpdateTruckZip3OverridesRequest = {
          id: this.newTruckZip3Overrides.id,
          facilityCode: this.newTruckZip3Overrides.facilityCode,
          overrideZip3: this.newTruckZip3Overrides.overrideZip3.toString(),
          zipCode: this.newTruckZip3Overrides.zipCode.toString()
        };
        const response = await truckZip3OverridesModuleState.updateTruckZip3Overrides(
          zip3OverridesRequest
        );
      }
    } catch (ex) {
      hasErrors = true;
      notifications.error("Truck Zip3 Overrides Saved", "Failed to save Truck Zip3 Overrides", ex);
    }

    this.saving = false;

    if (!hasErrors) {
      notifications.success(
        "Truck Zip3 Overrides Saved",
        "Successfully saved Truck Zip3 Overrides"
      );
      this.$router.push({ path: "/admin/truckZip3OverridesMaintenance" });
    }
  }
}

interface AddOverrideZip3ViewModel {
  id: number;
  facilityCode: string;
  zipCode: string;
  overrideZip3: string;
}
